import React, { Fragment, useState } from 'react';
import { injectIntl } from 'react-intl';
import { Box, Card, CardContent, FormControlLabel, Switch, Typography, IconButton } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import EditIcon from '@mui/icons-material/Edit';
import CurrencyInputDialog from './CurrencyInputDialog/CurrencyInputDialog';
import { decimalToString } from '../../../../../utils/formatNumber';

const labelSx = { color: 'text.secondary', fontSize: 14 };

export const CurrencyInputPanel = props => {
  const {
    intl,
    enabled,
    showIRR,
    onToggle,
    currency,
    onChange,
    template,
    linkedIllustration,
    returnRealizationRateEnabled,
    onReturnRealizationRateToggle
  } = props;

  const [dialogOpen, setDialogOpen] = useState(false);

  const openDialog = () => {
    setDialogOpen(true);
  };

  const onCloseDialog = currency => {
    if (currency !== undefined) {
      onChange(currency);
    }
    setDialogOpen(false);
  };

  const currencyLabel = enabled ? (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, lineHeight: 1 }}>
      <LockIcon color="error" fontSize="small" />
      <Typography sx={labelSx}>
        {intl.formatMessage({ id: 'pf-currency-enabled-heading' }, { currency: decimalToString(currency, 3) })}
      </Typography>
    </Box>
  ) : (
    <Typography sx={labelSx}>{intl.formatMessage({ id: 'pf-currency-disabled-heading' })}</Typography>
  );

  return (
    <Fragment>
      <CurrencyInputDialog currency={currency} open={dialogOpen} onClose={onCloseDialog} />

      <Card className="pfa-card pf-card-container pf-currency-input-panel">
        <CardContent style={{ padding: '0 12px', background: enabled ? '#ffe6e6' : '#fffbf5' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            {/* Row 1: currency toggle + pen (12px after label), trim trailing space */}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <FormControlLabel
                control={<Switch checked={!!enabled} onChange={onToggle} name="isCurrencyEnabled" color="primary" />}
                label={currencyLabel}
                sx={{ mr: 0, mb: 0 }}
              />
              {!template && (
                <IconButton size="small" onClick={openDialog} sx={{ ml: '12px', p: 0.5 }}>
                  <EditIcon style={{ fontSize: 16 }} />
                </IconButton>
              )}
            </Box>

            {/* Row 2: IRR | Return Realization Rate — even columns, space-between */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 1
              }}
            >
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <FormControlLabel
                  control={<Switch checked={!!showIRR} onChange={onToggle} name="showIRR" color="primary" />}
                  label={<Typography sx={labelSx}>{intl.formatMessage({ id: 'pf-irr-display-heading' })}</Typography>}
                  sx={{ mr: 0, mb: 0 }}
                />
              </Box>
              {linkedIllustration && (
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={!!returnRealizationRateEnabled}
                        onChange={onReturnRealizationRateToggle}
                        name="returnRealizationRateEnabled"
                        color="primary"
                        disabled={enabled}
                      />
                    }
                    label={
                      <Typography sx={labelSx}>
                        {intl.formatMessage({ id: 'pfa-return-realization-rate' })}
                      </Typography>
                    }
                    sx={{ mr: 0, mb: 0 }}
                  />
                </Box>
              )}
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Fragment>
  );
};

export default injectIntl(CurrencyInputPanel);
